"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _ApplicationContext = require("../../api/ApplicationContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LogoutLink = _ref => {
  let {
    logoutPath
  } = _ref;
  return _SecurityContextHolder.SecurityContextHolder.isAuthenticated() && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: logoutPath,
    className: "navbar-item logout-link"
  }, "Log Out");
};
LogoutLink.propTypes = {
  logoutPath: _propTypes.default.string
};
LogoutLink.defaultProps = {
  logoutPath: _ApplicationContext.ApplicationContext.getLogoutPath()
};
var _default = exports.default = LogoutLink;
//# sourceMappingURL=LogoutLink.js.map